<svelte:options runes={true} />

<script lang="ts">
  import IconInfo from "~icons/dusk/info";

  interface Props {
    message?: string;
  }

  let { message = "Something went wrong" }: Props = $props();
</script>

<div class="da-error-state">
  <IconInfo class="da-error-state__icon" aria-hidden="true" width="24" height="24" />
  <p class="da-error-state__message">{message}</p>
</div>

<style>
  @layer aurora {
    .da-error-state {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: var(--da-space-2);
      color: var(--da-color-text-muted);
    }

    .da-error-state__message {
      font-size: var(--da-font-size-xxs);
      font-weight: var(--da-font-weight-medium);
      line-height: var(--da-line-height-xxs);
      text-align: center;
      margin: 0;
    }

    :global(.da-error-state__icon) {
      flex-shrink: 0;
    }
  }
</style>
